import { render, staticRenderFns } from "./DpcInvoice.vue?vue&type=template&id=6c350366&"
import script from "./DpcInvoice.vue?vue&type=script&lang=js&"
export * from "./DpcInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DpcInvoice.vue?vue&type=style&index=0&id=6c350366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports